module.exports = __webpack_public_path__ + "img_left_side--left.b1dc879b1477327a999be86c971cc6f4.png";